import React from "react";
import {
    Button, CircularProgress, Paper, TextField, Typography, withStyles, IconButton, Dialog,
    DialogTitle, DialogActions, DialogContentText, DialogContent
} from "@material-ui/core";
import { NavigateBefore } from '@material-ui/icons';
import {logoFull} from "../../resources/images";
import APIService from "../../apis/amplify/APIService";
import If from '../../components/If';
import Fvt from '../../components/FieldValidationText';
import {styles} from './styles';
import ReactSwipeableViews from "react-swipeable-views"
import {errorBundaryHOC} from "../../components/ErrorBoundary";
import {communicationFailedText} from "../../util/texts";

class RecoverPassword extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            errorText: '',
            recoverStatus: 'Recover',
            recoverStep: 0,
            email: {
                value: '',
                primaryMessage: "",
                isValid: false
            },
            code: {
                value: '',
                primaryMessage: "",
                isValid: false
            },
            password: {
                value: '',
                primaryMessage: "",
                isValid: false
            },
            confirmPassword: {
                value: '',
                isValid: false
            },
            resetData: null,
            passwordChanged: false,
        };

        this.bindHandlers()
    }
    bindHandlers() {
        this.onCodeRequest = this.onCodeRequest.bind(this);
        this.onCodeEntered = this.onCodeEntered.bind(this);
        this.emailChanged = this.emailChanged.bind(this);
        this.codeChanged = this.codeChanged.bind(this);
        this.passwordChanged = this.passwordChanged.bind(this);
        this.confirmPasswordChanged = this.confirmPasswordChanged.bind(this);
    }
    async onCodeRequest(e) {
        this.setState({loading: true, errorText: ''});
        const {email} = this.state;
        if (email.isValid) {
            try {
                const response = await APIService.requestRecoverUserPassword(email.value);
                if (response.ok) {
                    this.setState({resetData: response.data, loading: false, errorText: '', recoverStep: 1});
                } else {
                    this.setState({loading: false, errorText: "User not found"});
                }
            } catch (e) {
                this.resetEmail();
                this.setState({errorText: communicationFailedText, loading: false});
            }
        }
    }
    async onCodeEntered(e) {
        this.setState({loading: true, errorText: ''});
        const {code, recoverStatus, email} = this.state;
        if (recoverStatus !== 'Recover') {
            const response = await APIService.requestRecoverUserPassword(email.value);
            if (response.ok) {
                this.resetToken();
                this.setState({loading: false, errorText: '', recoverStatus: "Recover"});
            } else {
                this.setState({loading: false, errorText: communicationFailedText});
            }
        } else
        if (code.isValid) {
            this.setState({loading: true, errorText: ''});
            const {password, confirmPassword, resetData} = this.state;
            if (password.isValid) {
                try {
                    if (password.value === confirmPassword.value) {
                        const data = {
                            user_id: resetData.id,
                            reset_token: code.value,
                            new_password : password.value
                        };
                        const response = await APIService.recoverUserPassword(data);
                        if (response.ok) {
                            this.setState({loading: false, errorText: '', passwordChanged: true});
                        } else {
                            this.setState({loading: false, errorText: "Invalid code", recoverStatus: "Request code again"});
                        }
                    }
                    else {
                        this.setState({loading: false, errorText: 'The passwords provided not matched.'});
                    }
                } catch (e) {
                    this.setState({errorText: communicationFailedText, loading: false});
                }
            }
        }
    }

    onLogin = event => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }
        this.props.history.replace('/login');
    };
    goToHome() {
        this.props.history.replace('/home');
    }
    resetEmail() {
        const value = {
            ...this.state.email,
            value: '',
        };
        this.setState({email: value});
    }
    resetToken() {
        const value = {
            ...this.state.code,
            value: '',
        };
        this.setState({code: value});
    }
    emailChanged(e) {
        const value = {
            ...this.state.email,
            value: e.target.value,
            ...this.isValidEmail(e.target.value)
        };
        this.setState({email: value});
    }
    codeChanged(e) {
        const value = {
            ...this.state.code,
            value: e.target.value,
            ...this.isValidCode(e.target.value)
        };
        this.setState({code: value});
    }
    isValidCode(e) {
        return e.length === 0 ? {
            primaryMessage: "The code must not be empty",
            isValid: false
        } : {
            primaryMessage: "",
            isValid: true
        }
    }
    confirmPasswordChanged(e) {
        const value = {
            ...this.state.email,
            value: e.target.value,
        };
        this.setState({confirmPassword: value});
    }
    passwordChanged(e) {
        const value = {
            ...this.state.email,
            value: e.target.value,
            ...this.isValidPassword(e.target.value)
        };
        this.setState({password: value});
    }
    isValidPassword(password) {
        if (password === "") {
            return {
                primaryMessage: "The password should be not empty.",
                isValid: false
            };
        }
        else if (password.length < 6) {
            return {
                primaryMessage: "The password must contain at least 6 characters",
                isValid: false
            };
        }
        else if (!password.match(/[a-z]/i) || !password.match(/[a-z]/i)) {
            return {
                primaryMessage: "The password should contain at least one lowercase letter and one uppercase letter",
                isValid: false
            };
        }
        else if (!password.match(/[0-9]/i)) {
            return {
                primaryMessage: "The password should contain at least one number",
                isValid: false
            };
        }
        else if (!password.match(/\W/i)) {
            return {
                primaryMessage: "The password should contain at least one special character (@#$%^! ...etc)",
                isValid: false
            };
        }
        return {
            primaryMessage: "",
            isValid: true
        };
    }
    isValidEmail(email) {
        if (email === "") {
            return {
                primaryMessage: "Required",
                isValid: false
            };
        }
        else if (!(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/).test(email)) {
            return {
                primaryMessage: "The provided email is not valid.",
                isValid: false
            };
        }
        return {
            primaryMessage: "",
            isValid: true
        };
    }

    render() {
        const {classes, history} = this.props;
        const {loading, recoverStatus, errorText, email, code, password, confirmPassword} = this.state;
        return (
            <div>

                <Dialog open={this.state.passwordChanged}>
                    <DialogTitle>
                        <Typography color="primary" variant="h6">Password reset</Typography>
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText align="center">
                            Your password has been reset successfully. Now you can authenticate using your new password.
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => history.replace('/login')} fullWidth color="secondary" variant="contained">
                            Login
                        </Button>
                    </DialogActions>
                </Dialog>

                <div className={classes.backgroundDiv}>
                    <div className={classes.logoDiv}>
                        <img src={logoFull} alt='' className={classes.logoImage}
                             onClick={this.goToHome.bind(this)}/>
                    </div>
                </div>

                <main className={classes.main}>
                    <Paper className={classes.paper}>
                        <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                            <IconButton onClick={this.onLogin} className={classes.backButton}>
                                <NavigateBefore/>
                            </IconButton>
                            <Typography component="h1" variant="h5" align='center' style={{ flexGrow: 0.7 }}>
                                Recover Password
                            </Typography>
                        </div>

                        <div>
                            <ReactSwipeableViews  index={this.state.recoverStep}>
                                <React.Fragment>
                                    <p align="center">We will send you an SMS code to your phone.</p>
                                    <Typography color='error'>{errorText}</Typography>
                                    <TextField name="email"
                                               value={email.value}
                                               onChange={this.emailChanged}
                                               error={!email.isValid}
                                               required autoComplete="email" autoFocus
                                               margin='normal' label='Email' fullWidth id="email" type='email'/>
                                    <Fvt>{email.primaryMessage}</Fvt>
                                    <Button onClick={this.onCodeRequest}
                                            disabled={loading || !email.isValid}
                                            fullWidth variant="contained" color="secondary"
                                            className={classes.submit}>
                                        {recoverStatus} <If as={CircularProgress} condition={loading} size={20}/>
                                    </Button>
                                </React.Fragment>
                                <React.Fragment>
                                    <p align="center">Enter the code sent to you.</p>
                                    <Typography color='error'>{errorText}</Typography>
                                    <TextField name="code"
                                               disabled={recoverStatus !== 'Recover'}
                                               value={code.value}
                                               onChange={this.codeChanged}
                                               error={!code.isValid}
                                               required autoComplete="code" autoFocus
                                               margin='normal' label='Code' fullWidth id="code" type='text'/>
                                    <Fvt>{code.primaryMessage}</Fvt>
                                    <TextField name="password"
                                               disabled={recoverStatus !== 'Recover'}
                                               value={password.value}
                                               onChange={this.passwordChanged}
                                               error={!password.isValid}
                                               required autoComplete="password" autoFocus
                                               margin='normal' label='Password' fullWidth id="password" type='password'/>
                                    <Fvt>{password.primaryMessage}</Fvt>
                                    <TextField name="confirmation"
                                               disabled={recoverStatus !== 'Recover'}
                                               value={confirmPassword.value}
                                               onChange={this.confirmPasswordChanged}
                                               error={!confirmPassword.isValid}
                                               required autoComplete="confirmation" autoFocus
                                               margin='normal' label='Confirm Password' fullWidth id="confirmation" type='password'/>
                                    <Button onClick={this.onCodeEntered}
                                            disabled={loading || !code.isValid}
                                            fullWidth variant="contained" color="secondary"
                                            className={classes.submit}>
                                        {recoverStatus} <If as={CircularProgress} condition={loading} size={20}/>
                                    </Button>
                                </React.Fragment>
                            </ReactSwipeableViews>
                        </div>
                    </Paper>
                </main>

            </div>
        );
    }
}

export default withStyles(styles)(errorBundaryHOC(RecoverPassword))
